import { Assets, Texture, Sprite } from 'pixi.js-legacy';
import type { ItemType } from '../../types';

/**
 * SVG 텍스쳐 캐시
 * SVG 아이콘을 텍스쳐로 로드하여 캐싱
 */
export class SvgTextureCache {
    private static instance: SvgTextureCache | null = null;
    private textures: Map<string, Texture> = new Map();
    private loaded: boolean = false;

    private constructor() {}

    static getInstance(): SvgTextureCache {
        if (!SvgTextureCache.instance) {
            SvgTextureCache.instance = new SvgTextureCache();
        }
        return SvgTextureCache.instance;
    }

    /**
     * 아이템 아이콘들을 미리 로드
     */
    async preload(): Promise<void> {
        if (this.loaded) return;

        const icons: string[] = ['heart', 'star', 'lightning', 'clock', 'bomb', 'magnet', 'ui-star'];

        const loadPromises = icons.map(async (icon) => {
            try {
                const texture = await Assets.load<Texture>(`/assets/icons/${icon}.svg`);
                this.textures.set(icon, texture);
            } catch (e) {
                console.warn(`Failed to load icon: ${icon}`, e);
            }
        });

        await Promise.all(loadPromises);
        this.loaded = true;
    }

    /**
     * 아이템 타입에 해당하는 텍스쳐 가져오기
     */
    getItemTexture(type: ItemType): Texture | null {
        return this.textures.get(type) || null;
    }

    /**
     * 텍스쳐 이름으로 가져오기
     */
    getTexture(name: string): Texture | null {
        return this.textures.get(name) || null;
    }

    /**
     * 아이템 타입에 해당하는 스프라이트 생성
     */
    createItemSprite(type: ItemType): Sprite | null {
        const texture = this.getItemTexture(type);
        if (!texture) return null;

        const sprite = new Sprite(texture);
        sprite.anchor.set(0.5);
        return sprite;
    }

    /**
     * 로드 여부
     */
    isLoaded(): boolean {
        return this.loaded;
    }

    /**
     * 정리
     */
    destroy(): void {
        for (const texture of this.textures.values()) {
            texture.destroy(true);
        }
        this.textures.clear();
        this.loaded = false;
        SvgTextureCache.instance = null;
    }
}

// 편의를 위한 글로벌 인스턴스 접근
export const svgTextureCache = SvgTextureCache.getInstance();
